import React, { Component, Fragment } from "react";
import "./AdministrationMain.css";
import { Link, withRouter } from "react-router-dom";
// import AdministrationLogoutContainer from "./AdministrationLogout/AdministrationLogoutContainer";
import { STATIC_IMAGES_URL,ADMIN_END_BRANDING_IMAGE_URL } from "../../Config/Config";


class AdministrationMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  logoutHandler = () => {
    alert("logoutHandler Works");
    // this.props.history.push({
    //   pathname: "/login_page"
    // });
  };
  render() {
    return (
      <Fragment>
        <div className="header-slider">
          <img
            src={STATIC_IMAGES_URL + "admin_njtransit_banner.jpg"}
            alt="not found"
          />
        </div>
        <div className="adm_container">
          <div className="admin-inner-container">
            <h1 className="adm_h1">Administration - Main</h1>
           
            
            <div className="main-section-box">
              <div className="main-col1">
              <div className="col-box">
                  <h4 className="link-heading">Banner Management</h4>
                  <div className="link-bo">
                    <p className="adm-p-link margin">
                    <span className="dot-star"><img src={ADMIN_END_BRANDING_IMAGE_URL+'1595487026493-Magenta-Star.png'} alt="not found" /></span> <Link className="adm_link1" to="/Manage_Banner">
                      Manage Banners
                      </Link>
                    </p>
                    <p className="adm_link1">
                    <span className="dot-star"><img src={ADMIN_END_BRANDING_IMAGE_URL+'1595487026493-Magenta-Star.png'} alt="not found" /></span> <Link className="admmin_link1" to="/Banner_Scheduler">
                      Schedule Banners
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
              <div className="main-col1  margin-third">
              <div className="col-box">
                  <h4 className="link-heading">Partner Setup</h4>
                  <div className="link-bo">
                    <p className="adm-p-link margin">
                    <span className="dot-star"><img src={ADMIN_END_BRANDING_IMAGE_URL+'1595487026493-Magenta-Star.png'} alt="not found" /></span> <Link className="adm_link1" to="list_of_applicants">
                      List of New Applicants
                      </Link>
                    </p>
                    <p className="adm-p-link margin">
                    <span className="dot-star"><img src={ADMIN_END_BRANDING_IMAGE_URL+'1595487026493-Magenta-Star.png'} alt="not found" /></span> <Link className="admmin_link1" to="/business_list">
                       Business Participants
                      </Link>
                    </p>
                   
                  </div>
                </div>
              </div>
              <div className="main-col1">
              <div className="col-box">
                  <h4 className="link-heading">Offers Management</h4>
                  <div className="link-bo">
                    <p className="adm-p-link margin">
                    <span className="dot-star"><img src={ADMIN_END_BRANDING_IMAGE_URL+'1595487026493-Magenta-Star.png'} alt="not found" /></span> <Link className="adm_link1" to="/RetailerCouponsForApproval">
                        Partner Offer for Approval 
                      </Link>
                    </p>
                    <p className="adm-p-link margin">
                    <span className="dot-star"><img src={ADMIN_END_BRANDING_IMAGE_URL+'1595487026493-Magenta-Star.png'} alt="not found" /></span> <Link className="adm_link1" to="/Upload_Coupon_Image">
                        Partner Offer Images
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="main-section-box margin">
            
              <div className="main-col1">
              <div className="col-box">
                  <h4 className="link-heading">User Management</h4>
                  <div className="link-bo">
                    <p className="adm-p-link margin">
                    <span className="dot-star"><img src={ADMIN_END_BRANDING_IMAGE_URL+'1595487026493-Magenta-Star.png'} alt="not found" /></span> <Link className="adm_link1" to="/UserManagement">
                      Manage Users
                      </Link>
                    </p>
                    <p className="adm-p-link margin">
                    <span className="dot-star"><img src={ADMIN_END_BRANDING_IMAGE_URL+'1595487026493-Magenta-Star.png'} alt="not found" /></span> <Link className="admmin_link1" to="/ManageMessaging">
                        Messaging
                      </Link>
                    </p>
                    <p className="adm-p-link">
                    <span className="dot-star"><img src={ADMIN_END_BRANDING_IMAGE_URL+'1595487026493-Magenta-Star.png'} alt="not found" /></span> <Link className="admmin_link1" to="/MessageHistory">
                        Messaging History
                      </Link>
                    </p>        
                  </div>
                </div>
              </div>
            </div>
    
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withRouter(AdministrationMain);
